// components/common/PrintAccountsTable.js
import React from 'react'
import { saveAs } from 'file-saver'
import {
  Document, Packer, Paragraph, Table, TableCell, TableRow, TextRun, ImageRun,
} from 'docx'
import { Button } from '@mui/material'

const PrintAccountsTable = ({ data, columns, filename = 'accounts.docx' }) => {
  const handlePrint = async () => {
    // Header row
    const headerRow = new TableRow({
      children: columns.map((col) =>
        new TableCell({
          children: [new Paragraph({ text: col.Header || '', bold: true })],
        })),
    })

    // Crear todas las filas del body de forma async paralela
    const rowPromises = data.map(async (row) => {
      const cells = await Promise.all(
        columns.map(async (col) => {
          const value = typeof col.accessor === 'function' ? await col.accessor(row) : row[col.accessor] || ''

          if (typeof value === 'object' && value?.type === 'image' && value.data) {
            return new TableCell({
              children: [
                new Paragraph({
                  children: [
                    new ImageRun({
                      data: Uint8Array.from(atob(value.data.split(',')[1]), (c) => c.charCodeAt(0)),
                      transformation: {
                        width: 100,
                        height: 100,
                      },
                    }),
                  ],
                }),
              ],
            })
          }

          return new TableCell({
            children: [new Paragraph({ children: [new TextRun(value?.toString() ?? '')] })],
          })
        }),
      )

      return new TableRow({ children: cells })
    })

    const bodyRows = await Promise.all(rowPromises)

    // Crear el documento con header + body
    const doc = new Document({
      sections: [
        {
          properties: {},
          children: [new Table({ rows: [headerRow, ...bodyRows] })],
        },
      ],
    })

    const blob = await Packer.toBlob(doc)
    saveAs(blob, filename)
  }

  return <Button onClick={handlePrint}>Exportar tabla a Word</Button>
}

export default PrintAccountsTable
